import styled from 'styled-components';

import { media } from 'utils/detection';
import withParallax from 'utils/parallax';

export default withParallax(styled.div`
  position: relative;
  display: block;
  width: calc(100% - 80px);
  max-width: 300px;
  border-bottom: 2px solid ${props => props.theme.textSemiDark};
  margin: 27px 0 0 0;
  left: 40px;

  ${media.medium`
    width: 35%;
    max-width: none;
    margin: 2.5vw 0 0 -10vw;
    left: 48%;
  `}
`);
